// ファーストビューの画像
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const targetLogo1 = document.getElementsByClassName('c_p-section-header-logo');
    const targetLogo2 = document.getElementsByClassName('c_p-section-header-logo-2');
    const targetConcept = document.getElementsByClassName('c_p-section-header-concept');
    const targetDate = document.getElementsByClassName('c_p-section-header-date');

    for (let i = 0; i < targetConcept.length; i++) {
      targetLogo1[i].classList.add('loaded');
      targetLogo2[i].classList.add('loaded');
      targetConcept[i].classList.add('loaded');
      targetDate[i].classList.add('loaded');
    }
  }, 100);
});

// ヘッダーの高さ
document.addEventListener('DOMContentLoaded', () => {
  const sectionHeader = document.querySelector('.shopify-section--header');
  const sectionFooter = document.querySelector('.footer-sp-menu');
  const sectionPlaylist = document.querySelector('.c_js-p-playlist-content');

  if (!sectionHeader || !sectionFooter || !sectionPlaylist) return;

  sectionFooter.setAttribute('hidden', '');
  sectionPlaylist.setAttribute('hidden', '');

  const sectionHeaderHeight = sectionHeader.offsetHeight;
  sectionHeader.style.marginBottom = `-${sectionHeaderHeight}px`;

  window.addEventListener('scroll', () => {
    const scrolledPastHeader = window.scrollY > sectionHeader.offsetTop + sectionHeaderHeight;
    sectionHeader.classList.toggle('is-solid', scrolledPastHeader);

    if (scrolledPastHeader) {
      sectionFooter.removeAttribute('hidden');
      sectionPlaylist.removeAttribute('hidden');
    } else {
      sectionFooter.setAttribute('hidden', '');
      sectionPlaylist.setAttribute('hidden', '');
    }
  });
});
